import React, { useState } from 'react';
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import FiltersPartial from './FiltersPartial.js';
import Listing from  './Listing.js'
import Page from "../../pages/Page";
import PageContentWrapper from "../../components/PageContentWrapper";

const Index = () => {
  const [filtersModel, setFiltersModel] = useState({});

  const defaultHeaderConfig = { disableSort: false };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Benificiary',
      value: (row) => {
        return <div className='d-block'>
          <div>
          ( {row.benifitiary_nomenclateure_id} ) -
          {row.benificiary_name} 
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer',
      value: (row) => {
        return <div className='d-block'>
          <div>
          ( {row.customer_nomenclature_id} ) -
          {row.customer_name}
            
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Offer Name',
      attr: 'offer_name',
      disableSort: true
    },

    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'CS serial no',
      attr: 'charging_station_serial_no',
      disableSort: true
    },    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    // {
    //   ...defaultHeaderConfig,
    //   label: 'Activated at',
    //   attr: 'activated_at',
    //   disableSort: false
    // },
    // {
    //   disableSort: false,
    //   label: 'Actions',
    //   value: (row) => {
    //     return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    //       <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_distributor_list.name)}>
    //         <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
    //           <FontAwesomeIcon icon={faEye} />
    //         </div>
    //       </UiAction>
    //     </div>
    //   }
    // }
  ]

  return <Page
      uiPage={uiManager.getUiPage(PAGES.EarningsListingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Earnings' }]}
      className={"earnings_listing-page"}
    >
        <Listing/>
    </Page>
};

export default Index;

